{
  "blocks": [
    {
      "id": "proc-carrier-testing",
      "kind": "procedure",
      "tags": ["genetic-screening", "both-partners", "lab"],
      "title": "Carrier testing",
      "subtitle": "Genetic screening for inherited conditions you could pass to your child",
      "body": {
        "procedureName": "Carrier testing",
        "category": "diagnostic",
        "description": "A blood or saliva test that screens for gene mutations associated with inherited conditions such as cystic fibrosis, sickle cell disease, spinal muscular atrophy, and fragile X syndrome. Carriers are healthy themselves but can pass the condition to their children.",
        "howItWorks": "A blood sample or saliva sample is collected and sent to a genetics laboratory. DNA is extracted and analyzed for mutations in specific genes, and expanded carrier panels can test for over 300 conditions at once. If both partners carry a mutation in the same gene, there is a 25% chance each pregnancy will be affected. Results help inform family planning decisions and determine whether preimplantation genetic testing (PGT-M) should be used during IVF.",
        "duration": "5–10 minutes for sample collection; results in 2–4 weeks",
        "anesthesia": "none",
        "painAndComfort": [
          "If collected by blood draw, expect a brief needle pinch and possible mild bruising at the draw site."
        ],
        "whatToExpect": [
          "A blood draw or saliva sample, quick and painless",
          "Results typically take 2–4 weeks",
          "A genetic counselor will review results and explain any findings",
          "If both partners are carriers of the same condition, options include PGT-M, donor gametes, or prenatal testing",
          "Being a carrier does not affect your own health"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "Carrier screening results usually take 2-4 weeks, depending on the panel size and genetics lab."
          },
          {
            "label": "What you learn",
            "detail": "The report shows whether either partner carries variants in tested genes. The highest concern is when both partners carry the same recessive condition."
          },
          {
            "label": "Follow-up",
            "detail": "A genetic counselor can explain reproductive risk and whether IVF with PGT-M, donor gametes, or prenatal testing should be considered."
          }
        ],
        "prepInstructions": [
          "No fasting or preparation needed",
          "Both partners should ideally be tested",
          "Prepare a family health history to discuss with the genetic counselor",
          "If using a saliva kit, avoid eating or drinking for 30 minutes before"
        ],
        "risks": [
          "Minor bruising if blood is drawn",
          "No physical risks from a saliva sample",
          "Possible emotional impact from learning carrier status, but genetic counseling is available"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Test de portage génétique",
          "description": "Analyse sanguine ou salivaire dépistant les mutations associées à des maladies génétiques (mucoviscidose, drépanocytose, amyotrophie spinale, X fragile, etc.). Les personnes porteuses sont elles-mêmes en bonne santé mais peuvent transmettre la maladie à leur enfant. En France, ce test n'est pas proposé en routine à toute la population. Il est demandé sur indication (antécédents familiaux, origine ethnique à risque, statut du partenaire, FCS à répétition) et n'est remboursé par l'Assurance Maladie que dans ce cadre.",
          "howItWorks": "Un échantillon de sang ou de salive est recueilli puis envoyé à un laboratoire de génétique. L'ADN est extrait et analysé à la recherche de mutations dans des gènes spécifiques ; les panels étendus peuvent rechercher plus de 300 maladies simultanément. Si les deux partenaires sont porteurs d'une mutation sur le même gène, il y a 25 % de risque que chaque grossesse soit affectée. Les résultats éclairent les décisions de planification familiale et l'indication d'un DPI-M (diagnostic préimplantatoire monogénique, PGT-M) en cas de FIV (fécondation in vitro).",
          "duration": "5 à 10 minutes pour le prélèvement ; résultats sous 2 à 4 semaines",
          "whatToExpect": [
            "Prise de sang ou prélèvement salivaire, rapide et indolore",
            "Résultats généralement disponibles sous 2 à 4 semaines",
            "Un conseiller en génétique examine les résultats et explique les éventuels résultats positifs",
            "Si les deux partenaires sont porteurs de la même maladie, les options incluent DPI-M, don de gamètes ou diagnostic prénatal",
            "Être porteur n'affecte pas votre propre santé"
          ],
          "prepInstructions": [
            "Aucun jeûne ni préparation nécessaire",
            "Les deux partenaires devraient idéalement être testés",
            "Préparez un historique familial à discuter avec le conseiller en génétique",
            "Pour un kit salivaire, évitez de manger ou boire 30 minutes avant"
          ],
          "risks": [
            "Léger hématome en cas de prise de sang",
            "Aucun risque physique pour un prélèvement salivaire",
            "Impact émotionnel possible à l'annonce d'un statut de porteur ; un accompagnement génétique est proposé"
          ]
        }
      },
      "sources": [
        {
          "title": "ACOG Committee Opinion 690: Carrier Screening in the Age of Genomic Medicine",
          "authors": "American College of Obstetricians and Gynecologists",
          "journal": "Obstetrics & Gynecology",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28225425/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Screening for autosomal recessive and X-linked conditions during pregnancy and preconception: a practice resource of the ACMG",
          "authors": "Gregg AR et al.",
          "journal": "Genetics in Medicine",
          "year": 2021,
          "url": "https://pubmed.ncbi.nlm.nih.gov/34914171/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "proc-carrier-testing",
      "to": "test-carrier-screening",
      "type": "related-to",
      "label": "Canonical test"
    }
  ],
  "localeVariants": []
}
